import React from 'react';
import classes from './CustomCheckbox.module.css';

const customCheckbox = (props) => {
  const containerClasses = [classes.container];
  if (props.type) containerClasses.push(classes[props.type]);
  return (
    <label className={containerClasses.join(' ')}>
      {props.label}
      <input onClick={props.checked} type="checkbox" />
      <span className={classes.checkmark} />
    </label>
  );
};

export default customCheckbox;
